import React, { useState } from 'react'
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3'
import { getSignedUrl } from '@aws-sdk/s3-request-presigner'
import isEmpty from 'lodash/isEmpty'
import { getJWTPayload } from '../Utils/tokens'
import { NakedButton } from '@cb/apricot-react'
import { saveAs } from 'file-saver'
import { setModalOptions } from '@landscape/ui-redux'
import { Spinner } from '../Spinner'
import { useDispatch } from 'react-redux'

const { VITE_REACT_APP_RESULT_BUCKET } = import.meta.env
const DOMAIN_NAME = 'tecd'
const cb = window.cb

const downloadFileFromS3 = async (
  bucket: string,
  prefix: string,
  fileName: string,
  fileKey: string,
  setLoading: (loading: boolean) => void
) => {
  const jwtPayload = getJWTPayload()
  const awsCredentials = cb.core.iam.getTempAWSCreds(DOMAIN_NAME)

  if (awsCredentials && jwtPayload) {
    setLoading(true)
    const s3Client = new S3Client({ region: 'us-east-1', credentials: awsCredentials })

    // Get a signed url to the file in S3. Expire in 60 seconds.
    const params = {
      Bucket: bucket,
      Key: isEmpty(prefix) ? fileKey : `${prefix}/${fileKey}`,
    }
    const command = new GetObjectCommand(params)
    const signedUrl = await getSignedUrl(s3Client, command, { expiresIn: 60 })

    // Download file
    fetch(signedUrl)
      .then((res) => res.blob())
      .then((blob) => {
        saveAs(blob, fileName)
      })
      .catch((err) => {
        throw err
      })
      .finally(() => {
        setLoading(false)
      })
  }
}

interface FileDownloadRow {
  di_code: string
  fileKey: string
  fileName: string
}

export const AggFileDownload = (props: any) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const row: FileDownloadRow = props.row ?? {}

  let { fileKey, fileName } = row

  const handleFileDownload = (evt: React.MouseEvent) => {
    // evt.preventDefault()
    try {
      downloadFileFromS3(
        VITE_REACT_APP_RESULT_BUCKET,
        '',
        `${fileName}.csv`,
        fileKey,
        setLoading
      )
    } catch (error: any) {
      console.log(error)
      dispatch(
        setModalOptions({
          showModal: true,
          body: [`${error.message}` || 'Error Downloading File.'],
          status: 'danger',
          title: 'File Download Error',
          primaryLabel: 'OK',
          confirm: false,
        })
      )
    }
  }

  return !loading ? (
    <>
      <NakedButton aria-label="Download agg file" onClick={handleFileDownload}>
        {fileName}
      </NakedButton>
    </>
  ) : (
    <Spinner size="xs" showSpinner={true} id="agg-file" ariaLabel="Downloading..." />
  )
}
